import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "@app/app.component";
import { appConfig } from "@app/app.config";

// Only to debug stack traces, uncomment the following block
/*(Error as any).prepareStackTrace = (_: unknown, stack: unknown[] | undefined): unknown[] | undefined => {
    console.error("STACK TRACE:\n", stack?.join("\n"));
    return stack;
};*/

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
